module.exports = __webpack_public_path__ + "img/QC.f2a0e32e.png";